/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Alert } from 'react-bootstrap';
import BasicTenantForm from '../BasicTenantForm';
import Button from '../../../../modules/react/components/stateless/Button';
import Form from '../../../../modules/react/components/stateful/Form';
import styles from './styles.scss';

export default class CouponForm extends React.Component {
  static propTypes = {
    coupon: PropTypes.shape({
      style: PropTypes.string,
      text: PropTypes.string,
      title: PropTypes.string,
    }),
    facilityId: PropTypes.string,
    isRequesting: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    onSubmitSuccess: PropTypes.func,
    errorMessage: PropTypes.string,
  };

  static defaultProps = {
    coupon: undefined,
    facilityId: undefined,
    onClose: undefined,
    onSubmit: undefined,
    onSubmitSuccess: undefined,
    errorMessage: '',
  }

  state = {
    showErrorMessage: false,
  }

  handleRequest = (data) => {
    if (!data.firstName || (!data.phone && !data.email)) {
      return this.setState({ showErrorMessage: true });
    }

    const { coupon, facilityId, onSubmit } = this.props;
    const { ...tenant } = data;

    if (tenant.phone) {
      tenant.phone = tenant.phone.replace(/\D/g, '');
    }

    return onSubmit(facilityId, coupon, tenant);
  };

  render() {
    const {
      isRequesting, onClose, onSubmitSuccess, errorMessage,
    } = this.props;
    const { showErrorMessage } = this.state;

    return (
      <Form
        form="couponModal"
        onSubmit={this.handleRequest}
        onSubmitSuccess={onSubmitSuccess}
      >
        <Modal.Header className={styles.closeButton} closeButton>
          <Modal.Title className={`${styles.header} color-primary-foreground`}>Request a Coupon</Modal.Title>
        </Modal.Header>
        {showErrorMessage && <Alert variant="danger">First Name and Phone Number OR Email is required.</Alert>}
        <Modal.Body>
          <p className={styles.blurb}>
            To receive a coupon instantly, just provide your name and email address below. A copy will also be
            emailed to you. You are required to provide a first name and either a phone number or email address.
          </p>
          {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
          <BasicTenantForm />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="default" onClick={onClose}>Cancel</Button>
          <Button
            variant="primary"
            className="color-secondary-background color-primary-background-hover"
            disabled={isRequesting}
            type="submit"
          >
            Request Coupon
          </Button>
        </Modal.Footer>
      </Form>
    );
  }
}
